import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const wipeTeamSupportV2 = {
  name: "wipeTeamSupportV2" as const,
  input: z.object({ teamId: zExt.objectId() }).strict(),
  output: z.object({ workflowId: z.string() }),
};
